import { useSelector } from 'react-redux';
import ABSSearch from '@abs/core/ABSSearch';
import { selectFlatNavigation } from 'app/store/abs/navigationSlice';

function NavigationSearch(props) {
  const { variant, className } = props;
  const navigation = useSelector(selectFlatNavigation);

  return <ABSSearch className={className} variant={variant} navigation={navigation} />;
}

export default NavigationSearch;
